import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { getAllRouteParams } from '../../lib/get-all-route-params';
import { getFullPath } from '../../lib/get-full-path';
import { PICFLOW_MAINTENANCE } from '../../maintenance';
import { RedirectService } from '../../services/redirect.service';
import { getBaseWithoutKey } from '../libs/base-without-key';

@Injectable({
  providedIn: 'root',
})
export class GalleryMaintenanceGuard {
  private redirectService = inject(RedirectService);
  private platformId = inject<string>(PLATFORM_ID);
  private maintenance = inject(PICFLOW_MAINTENANCE);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    if (await firstValueFrom(this.maintenance.getRealTimeMaintenanceMode())) return true;
    const fullPath = getFullPath(next);
    const params = getAllRouteParams(next);
    const idOrPath = params.galleryPath || params.galleryId;
    const { baseWithoutKey, rest } = getBaseWithoutKey(fullPath, idOrPath);
    return this.redirectService.redirectTo([...baseWithoutKey, ...rest], { queryParams: next.queryParams });
  }
}
